import Banner from "./Banner/index";
import DataLaunch from "./DataLaunch/index";
import Why from "./Why/index";
import OurCommunity from "./OurCommunity/index";
import Support from "./Support/index";
import Process from "./Process/index";
import ATH from "./ATH/index";
import Raise from "./Raise/index";
import Partners from "./Partners/index";
import Network from "./Network";
import Average from "./Average";
import Community from "./ComunitySupport";
import "./style.css";

const ApplyLaunch = () => {
  return (
    <div style={{ background: '#FBFBFC' }}>
      <Banner />
      <DataLaunch />
      <Network />
      <Why />
      <OurCommunity />
      <Support />
      <Partners />
      <Average />
      <Process />
      <ATH />
      <Community />
      <Raise />
    </div>
  );
};

export default ApplyLaunch;
